import React from 'react';
import HandymanIcon from '@mui/icons-material/Handyman';

export default (props: any) => {
  return <HandymanIcon style={{ fontSize: 14 }} color="warning" {...props} />;
};
